<template>
  <button
    class="min-h-6"
    data-gtm-action="show nutrition info"
    :data-gtm-label="productTitle"
    @click.prevent="handleClick"
  >
    <slot />
  </button>
</template>

<script setup lang="ts">
import { ProductNutritionModal } from '@oatsovernight/storybook'
import { useProductsStore, useThemeStore } from '@/stores'

const props = defineProps<{
  productId: string
  productTitle: string
}>()

const { modal } = useThemeStore()
const store = useProductsStore()

const handleClick = () => {
  const product = store.productList.find(p => String(p.id) === props.productId)
  modal.open(ProductNutritionModal, { product })
}
</script>
